import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { OfferTeaser } from "./components/OfferTeaser";
import { StorySection } from "./components/StorySection";
import { FrameworkSection } from "./components/FrameworkSection";
import { PainPointsSection } from "./components/PainPointsSection";
import { VolumesSection } from "./components/VolumesSection";
import { ToolsSection } from "./components/ToolsSection";
import { BonusesSection } from "./components/BonusesSection";
import { OfferSection } from "./components/OfferSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { BeforeAfterSection } from "./components/BeforeAfterSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { AuthorSection } from "./components/AuthorSection";
import { FAQSection } from "./components/FAQSection";
import { FinalCTASection } from "./components/FinalCTASection";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans" data-id="element-0" data-mp="3mj6jhwnqi0fz">
      <MetaPixel data-id="element-1" data-mp="3rd189ei755lx" />
      <Hero data-id="element-2" data-mp="3relwynhtxubv" />
      <main data-id="element-3" data-mp="5ott78p769p">
        <OfferTeaser data-id="element-4" data-mp="6htxpd5ixiv" />
        <StorySection data-id="element-5" data-mp="4n53zyrel9i" />
        <FrameworkSection data-id="element-6" data-mp="56lhc8rh1lf" />
        <PainPointsSection data-id="element-7" data-mp="2zl3c5m4yv85u" />
        <VolumesSection data-id="element-8" data-mp="2zlv8x0aavbxp" />
        <ToolsSection data-id="element-9" data-mp="2zmo4d53t6f0j" />
        <BonusesSection data-id="element-10" data-mp="2zn66ujh2dpgw" />
        <OfferSection data-id="element-11" data-mp="33mf1rrnubte1" />
        <GuaranteeSection data-id="element-12" data-mp="33nq6btp41567" />
        <BeforeAfterSection data-id="element-13" data-mp="33n6w6z5pbl2q" />
        <TestimonialsSection data-id="element-14" data-mp="38lromcepp0gm" />
        <AuthorSection data-id="element-15" data-mp="38li8rhnds9on" />
        <FAQSection data-id="element-16" data-mp="38l017ov9q91f" />
        <FinalCTASection data-id="element-17" data-mp="38nup5qdhqbzl" />
      </main>
      <Footer data-id="element-18" data-mp="3dle1gkqmoeow" />
      <FloatingCTA data-id="element-19" data-mp="3dl4jnkfqldua" />
      <PurchasePopup data-id="element-20" data-mp="3dmfq5s0kgzp3" />
    </div>;
}